import type { GarmentTimelineSource } from '@/api/generated/enums';

// The website's icon per track; the rest of the timeline's vocabulary is shared from the core
// (`@core/units/timeline`), and the phone keeps its own Lucide equivalent.
/** The glyph each track is known by, matching the menu entry it comes from. */
export const sourceIcon: Record<GarmentTimelineSource, string> = {
  None: 'icon icon-circle-dot',
  Status: 'icon icon-shirt',
  Block: 'icon icon-calendar-days',
  Booking: 'icon icon-clipboard-list',
  Job: 'icon icon-washing-machine',
};
